import React from 'react';
import {Fab} from 'native-base';
import {LocalizationOffIcon, LocalizationOnIcon} from '../icons';

interface Props {
  onTap?: () => void;
  switchedOn: boolean;
}

const LocalizationItem = function (props: Props) {
  const {onTap: handleOnTap, switchedOn} = props;

  const handlePress = () => {
    if (handleOnTap) {
      handleOnTap();
    }
  };

  return (
    <>
      <Fab
        renderInPortal={false}
        shadow={2}
        right={4}
        bottom={95}
        icon={switchedOn ? <LocalizationOnIcon /> : <LocalizationOffIcon />}
        onPress={handlePress}
        boxSize="70"
      />
    </>
  );
};

export default LocalizationItem;
